import {
  Alert,
  Autocomplete,
  Paper,
  TextField as MuiTextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { PageHeader } from '../../../components/layout/page-header';
import { trpc } from '../../../../trpc/react';
import { CricketOrgSeedCommand } from './CricketOrgSeedCommand';

type OrgOption = { id: string; name: string };

export function DevelopersPage() {
  const [selectedOrgId, setSelectedOrgId] = useState<string | null>(null);
  const orgsQuery = trpc.admin.orgs.useQuery(undefined);

  return (
    <div className="flex flex-col h-full overflow-auto">
      <PageHeader title="Developers" />
      <div className="flex flex-col gap-6 p-6">
        <Paper className="p-6">
          <Typography variant="h2" className="mb-4">
            Organization
          </Typography>
          <Autocomplete
            options={(orgsQuery.data ?? []) as OrgOption[]}
            getOptionLabel={(option: OrgOption) => option.name}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            value={
              (orgsQuery.data as OrgOption[] | undefined)?.find(
                (org) => org.id === selectedOrgId,
              ) ?? null
            }
            onChange={(_, newValue: OrgOption | null) =>
              setSelectedOrgId(newValue?.id ?? null)
            }
            renderInput={(params) => (
              <MuiTextField
                {...params}
                label="Organization"
                placeholder="Select an organization"
              />
            )}
            loading={orgsQuery.isLoading}
            fullWidth
          />
          {orgsQuery.isError && (
            <Alert severity="error" className="mt-4">
              Failed to load organizations: {orgsQuery.error.message}
            </Alert>
          )}
        </Paper>

        {/* key remounts on org change to reset the command's own success/error state */}
        <CricketOrgSeedCommand
          key={selectedOrgId ?? 'no-org'}
          orgId={selectedOrgId}
        />
      </div>
    </div>
  );
}
